import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    backgroundColor: capitalDesignTokens.foundations.colors.gray200
  },
  active: {
    backgroundColor: capitalDesignTokens.foundations.colors.gray300
  }
});
